<script setup lang="ts">
withDefaults(defineProps<{
  id: string
  variant?: 'default' | 'sale'
}>(), {
  variant: 'default',
});

const { t } = useI18n();
const { m } = useIadFormat();
const { value: firstName, errorMessage: errorMessageFirstName } = useField<string>(`firstName`);
const { value: lastName, errorMessage: errorMessageLastName } = useField<string>(`lastName`);
const { value: email, errorMessage: errorMessageEmail } = useField<string>(`email`);
const { value: message } = useField<string>(`message`);
const { value: adSubscription } = useField<boolean>(`adSubscription`);
const { value: adPartnerSubscription } = useField<boolean>(`adPartnerSubscription`);

const errorFirstName = computed(() => errorMessageFirstName.value ? t(errorMessageFirstName.value) : undefined);
const errorLastName = computed(() => errorMessageLastName.value ? t(errorMessageLastName.value) : undefined);
const errorEmail = computed(() => errorMessageEmail.value ? t(errorMessageEmail.value) : undefined);

const displayMessageArea = ref(false);
</script>

<template>
  <IadInputText
    v-model="firstName"
    :name="`${id}-firstName`"
    :label="m(`core.common.first_name`)"
    :placeholder="$t(`agent.form.first_name_placeholder`)"
    :error="errorFirstName"
  />
  <IadInputText
    v-model="lastName"
    :name="`${id}-lastName`"
    :label="m(`core.common.last_name`)"
    :placeholder="$t(`agent.form.last_name_placeholder`)"
    :error="errorLastName"
  />
  <IadInputText
    v-model="email"
    :name="`${id}-email`"
    :label="m(`core.common.email`)"
    placeholder="email@mail.com"
    type="email"
    :error="errorEmail"
  />
  <IadInputPhone
    name="phone"
    :label="m(`core.common.phone`)"
    :placeholder="m(`core.common.phone`)"
  />
  <div class="flex flex-col gap-xs pt-xs">
    <IadLinkMoreLess
      v-if="variant === 'default'"
      v-model="displayMessageArea"
      :text="$t(`property.contact_agent.add_message`)"
    />
    <IadTextarea
      v-if="displayMessageArea"
      v-model="message"
      :name="`${id}-message`"
      :label="$t(`core.common.message`)"
      :placeholder="$t(`agent.form.message_placeholder`)"
      :maxlength="1_000"
    />
    <IadCheckbox
      v-model="adSubscription"
      :name="`${id}-adSubscription`"
      class="text-neutral-10"
      :label="$t(`property.contact_agent.similar_ads_subscription`)"
    />
    <IadCheckbox
      v-model="adPartnerSubscription"
      :name="`${id}-adPartnerSubscription`"
      class="text-neutral-10"
      :label="$t(`property.contact_agent.similar_ads_partners_subscription`)"
    />
    <small
      class="text-sm text-neutral-40"
      v-text="$t(`core.common.required_field`)"
    />
  </div>
</template>
